import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { Page as Component } from "~/components/specifics/vendors/settings/line_user_accounts/Page";
import { useLineUserAccounts } from "~/hooks/vendors/useLineUserAccounts";

export const PATH = "/vendors/settings/line_user_accounts";

const LineUserAccounts: NextPage = () => {
	const { data: lineUserAccounts } = useLineUserAccounts().index();

	return (
		<>
			<NskHead title="LINEアカウント設定" />
			<VendorLayoutV2>
				{lineUserAccounts === null ? null : (
					<Component lineUserAccounts={lineUserAccounts} />
				)}
			</VendorLayoutV2>
		</>
	);
};

export default LineUserAccounts;
